var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "shift-record" },
    [
      _c(
        "div",
        { staticClass: "search-term" },
        [
          _c(
            "el-form",
            { attrs: { inline: true, model: _vm.searchInfo } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "交班油站" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        clearable: "",
                        filterable: "",
                        placeholder: "请选择"
                      },
                      model: {
                        value: _vm.searchInfo.stationId,
                        callback: function($$v) {
                          _vm.$set(_vm.searchInfo, "stationId", $$v)
                        },
                        expression: "searchInfo.stationId"
                      }
                    },
                    _vm._l(_vm.stationOptions, function(item) {
                      return _c("el-option", {
                        key: item.ID,
                        attrs: { label: item.stationName, value: item.ID }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.onSubmit } },
                    [_vm._v("查询")]
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c("el-button", { on: { click: _vm.onReset } }, [
                    _vm._v("重置")
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-table",
        {
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.tableData,
            border: "",
            stripe: "",
            "tooltip-effect": "dark"
          },
          on: { "selection-change": _vm.handleSelChange }
        },
        [
          _c("el-table-column", {
            attrs: { prop: "ID", width: "40", type: "selection" }
          }),
          _c("el-table-column", {
            attrs: { label: "油站", prop: "stationId" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(
                      _vm._s(_vm._f("getStationName")(scope.row.stationId))
                    )
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { label: "班次", prop: "shiftName" }
          }),
          _c("el-table-column", {
            attrs: { label: "开始时间", prop: "startDate" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(_vm._s(_vm._f("formatDate")(scope.row.startDate)))
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { label: "结束时间", prop: "endDate" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(_vm._s(_vm._f("formatDate")(scope.row.endDate)))
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { label: "操作", width: "150" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    scope.row.shiftInfoStatus == 2
                      ? _c(
                          "el-button",
                          {
                            staticClass: "table-button",
                            attrs: { size: "small", type: "primary" },
                            on: {
                              click: function($event) {
                                return _vm.onView(scope.row)
                              }
                            }
                          },
                          [_vm._v("查看")]
                        )
                      : _vm._e(),
                    scope.row.shiftInfoStatus == 0
                      ? _c(
                          "el-button",
                          {
                            staticClass: "table-button",
                            attrs: { size: "small", type: "primary" },
                            on: {
                              click: function($event) {
                                return _vm.onUpdate(scope.row)
                              }
                            }
                          },
                          [_vm._v("录入")]
                        )
                      : _vm._e(),
                    scope.row.shiftInfoStatus == 1
                      ? _c(
                          "el-button",
                          {
                            staticClass: "table-button",
                            attrs: { size: "small", type: "primary" },
                            on: {
                              click: function($event) {
                                return _vm.onCheck(scope.row)
                              }
                            }
                          },
                          [_vm._v("校对")]
                        )
                      : _vm._e()
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _c("el-pagination", {
        style: { float: "right", padding: "20px" },
        attrs: {
          "current-page": _vm.page,
          "page-size": _vm.pageSize,
          "page-sizes": [10, 30, 50, 100],
          total: _vm.total,
          layout: "total, sizes, prev, pager, next, jumper"
        },
        on: {
          "current-change": _vm.handleCurrentChange,
          "size-change": _vm.handleSizeChange
        }
      }),
      _c(
        "el-dialog",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.fullscreenLoading,
              expression: "fullscreenLoading"
            }
          ],
          attrs: {
            title: "录入交班数据",
            visible: _vm.addDialogVisible,
            "custom-class": "bairun-dialog bairun-dialog-large",
            "before-close": _vm.closeDialog
          },
          on: {
            "update:visible": function($event) {
              _vm.addDialogVisible = $event
            }
          }
        },
        [
          _c(
            "el-form",
            { staticStyle: { "font-weight": "bold" }, attrs: { inline: true } },
            [
              _c("el-form-item", { attrs: { label: "交班油站:" } }, [
                _vm._v(" " + _vm._s(_vm.shiftTableData.stationName) + " ")
              ]),
              _c(
                "el-form-item",
                {
                  staticStyle: { "margin-left": "30px" },
                  attrs: { label: "交班班次:" }
                },
                [_vm._v(" " + _vm._s(_vm.shiftTableData.shiftName) + " ")]
              )
            ],
            1
          ),
          _c(
            "el-row",
            { staticClass: "bairun-dialog-table", attrs: { gutter: 20 } },
            [
              _c(
                "el-tabs",
                {
                  model: {
                    value: _vm.activeName,
                    callback: function($$v) {
                      _vm.activeName = $$v
                    },
                    expression: "activeName"
                  }
                },
                [
                  _c(
                    "el-tab-pane",
                    { attrs: { label: "油枪数据", name: "oilGunData" } },
                    [
                      _c(
                        "el-table",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            data: _vm.shiftTableData.oilGunOilMassEndList,
                            border: "",
                            stripe: "",
                            "tooltip-effect": "dark",
                            "row-class-name": "shift-dialog-table-row"
                          }
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              label: "枪号",
                              prop: "oilGunNo",
                              align: "center"
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _vm._v(_vm._s(scope.row.oilGunNo) + "号枪")
                                  ]
                                }
                              }
                            ])
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "交班表底数(升)",
                              prop: "checkGunEndMass",
                              align: "center"
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c("el-input-number", {
                                      staticClass:
                                        "bairun-input-fill shift-record-input",
                                      staticStyle: { height: "47px" },
                                      attrs: {
                                        placeholder: "表底升数",
                                        precision: 2,
                                        min: 0,
                                        clearable: ""
                                      },
                                      on: {
                                        input: function($event) {
                                          return _vm.inputChange($event)
                                        }
                                      },
                                      model: {
                                        value: scope.row.checkGunEndMass,
                                        callback: function($$v) {
                                          _vm.$set(
                                            scope.row,
                                            "checkGunEndMass",
                                            $$v
                                          )
                                        },
                                        expression: "scope.row.checkGunEndMass"
                                      }
                                    })
                                  ]
                                }
                              }
                            ])
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "交班表底数拍照",
                              prop: "checkImg",
                              align: "center"
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c(
                                      "el-upload",
                                      {
                                        ref:
                                          "oilGunUpload" + scope.row.oilGunNo,
                                        staticClass:
                                          "shift-record-uploader bairun-required",
                                        attrs: {
                                          action:
                                            _vm.path +
                                            "/fileUploadAndDownload/upload",
                                          "before-upload": _vm.uploadBefore,
                                          headers: { "x-token": _vm.token },
                                          "on-error": _vm.uploadError,
                                          "on-success": function(
                                            res,
                                            file,
                                            fileList
                                          ) {
                                            _vm.uploadSuccess(
                                              res,
                                              file,
                                              fileList,
                                              scope.row,
                                              "checkImg"
                                            )
                                          },
                                          "show-file-list": false,
                                          accept: "image/*"
                                        }
                                      },
                                      [
                                        _c("i", {
                                          staticClass:
                                            "el-icon-plus shift-record-uploader-icon"
                                        })
                                      ]
                                    ),
                                    scope.row.checkImg != ""
                                      ? _c(
                                          "span",
                                          {
                                            staticClass: "shift-record-uploader"
                                          },
                                          [
                                            _c("img", {
                                              staticStyle: {
                                                height: "100%",
                                                width: "100%"
                                              },
                                              attrs: { src: scope.row.checkImg }
                                            }),
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "el-upload-list__item-actions"
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "el-upload-list__item-preview",
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.handleUploadPreview(
                                                          scope.row,
                                                          "checkImg"
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "el-icon-zoom-in"
                                                    })
                                                  ]
                                                ),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "el-upload-list__item-delete",
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.handleUploadRemove(
                                                          scope.row,
                                                          "checkImg",
                                                          "oilGunUpload" +
                                                            scope.row.oilGunNo
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "el-icon-delete"
                                                    })
                                                  ]
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ]
                                }
                              }
                            ])
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-tab-pane",
                    { attrs: { label: "支付数据", name: "payData" } },
                    [
                      _c(
                        "el-table",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            data: _vm.shiftTableData.shiftPaywayList,
                            border: "",
                            stripe: "",
                            "tooltip-effect": "dark",
                            "row-class-name": "shift-dialog-table-row"
                          }
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              label: "支付方式",
                              prop: "payWayName",
                              align: "center"
                            }
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "录入单数",
                              prop: "checkOrders",
                              align: "center"
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c("el-input-number", {
                                      staticClass:
                                        "bairun-input-fill shift-record-input",
                                      staticStyle: { height: "47px" },
                                      attrs: {
                                        placeholder: "订单数量",
                                        precision: 0,
                                        min: 0,
                                        clearable: ""
                                      },
                                      on: {
                                        input: function($event) {
                                          return _vm.inputChange($event)
                                        }
                                      },
                                      model: {
                                        value: scope.row.checkOrders,
                                        callback: function($$v) {
                                          _vm.$set(
                                            scope.row,
                                            "checkOrders",
                                            $$v
                                          )
                                        },
                                        expression: "scope.row.checkOrders"
                                      }
                                    })
                                  ]
                                }
                              }
                            ])
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "录入应付金额",
                              prop: "checkPayablesAmount",
                              align: "center"
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c("el-input-number", {
                                      staticClass:
                                        "bairun-input-fill shift-record-input",
                                      staticStyle: { height: "47px" },
                                      attrs: {
                                        placeholder: "应付金额",
                                        precision: 2,
                                        min: 0,
                                        clearable: ""
                                      },
                                      on: {
                                        input: function($event) {
                                          return _vm.inputChange($event)
                                        }
                                      },
                                      model: {
                                        value: scope.row.checkPayablesAmount,
                                        callback: function($$v) {
                                          _vm.$set(
                                            scope.row,
                                            "checkPayablesAmount",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "scope.row.checkPayablesAmount"
                                      }
                                    })
                                  ]
                                }
                              }
                            ])
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "录入实付金额",
                              prop: "checkPaymentsAmount",
                              align: "center"
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c("el-input-number", {
                                      staticClass:
                                        "bairun-input-fill shift-record-input",
                                      staticStyle: { height: "47px" },
                                      attrs: {
                                        placeholder: "实付金额",
                                        precision: 2,
                                        min: 0,
                                        clearable: ""
                                      },
                                      on: {
                                        input: function($event) {
                                          return _vm.inputChange($event)
                                        }
                                      },
                                      model: {
                                        value: scope.row.checkPaymentsAmount,
                                        callback: function($$v) {
                                          _vm.$set(
                                            scope.row,
                                            "checkPaymentsAmount",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "scope.row.checkPaymentsAmount"
                                      }
                                    })
                                  ]
                                }
                              }
                            ])
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c("el-button", { on: { click: _vm.closeDialog } }, [
                _vm._v("取 消")
              ]),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.handleSave } },
                [_vm._v("暂存")]
              ),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.handleSubmit } },
                [_vm._v("提交")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "异常备注",
            visible: _vm.checkDialogVisible,
            "custom-class": "bairun-dialog bairun-dialog-large",
            "before-close": _vm.closeDialog
          },
          on: {
            "update:visible": function($event) {
              _vm.checkDialogVisible = $event
            }
          }
        },
        [
          _c(
            "el-form",
            { staticStyle: { "font-weight": "bold" }, attrs: { inline: true } },
            [
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 4 } },
                    [
                      _c("el-form-item", { attrs: { label: "交班油站:" } }, [
                        _vm._v(
                          " " + _vm._s(_vm.shiftTableData.stationName) + " "
                        )
                      ])
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 4 } },
                    [
                      _c("el-form-item", { attrs: { label: "交班班次:" } }, [
                        _vm._v(" " + _vm._s(_vm.shiftTableData.shiftName) + " ")
                      ])
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 16 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          class: _vm.type == "check" ? "bairun-required" : "",
                          attrs: { label: "异常备注:" }
                        },
                        [
                          _c("el-input", {
                            staticStyle: { width: "600px" },
                            attrs: {
                              type: "textarea",
                              clearable: "",
                              placeholder: "请输入异常原因",
                              rows: 3
                            },
                            on: {
                              input: function($event) {
                                return _vm.inputChange($event)
                              }
                            },
                            model: {
                              value: _vm.shiftTableData.remark,
                              callback: function($$v) {
                                _vm.$set(_vm.shiftTableData, "remark", $$v)
                              },
                              expression: "shiftTableData.remark"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-tabs",
            {
              model: {
                value: _vm.activeName,
                callback: function($$v) {
                  _vm.activeName = $$v
                },
                expression: "activeName"
              }
            },
            [
              _c(
                "el-tab-pane",
                { attrs: { label: "油枪数据", name: "oilGunData" } },
                [
                  _c(
                    "el-row",
                    {
                      staticClass: "bairun-dialog-table",
                      attrs: { gutter: 20 }
                    },
                    [
                      _c(
                        "el-table",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            data: _vm.shiftTableData.oilGunOilMassEndList,
                            border: "",
                            stripe: "",
                            "tooltip-effect": "dark",
                            "row-class-name": "shift-dialog-table-row"
                          }
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              label: "枪号",
                              prop: "oilGunNo",
                              align: "center"
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _vm._v(_vm._s(scope.row.oilGunNo) + "号枪")
                                  ]
                                }
                              }
                            ])
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "交班表底数(升)",
                              prop: "checkGunEndMass",
                              align: "center"
                            }
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "交班表底数拍照",
                              prop: "checkImg",
                              align: "center"
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c(
                                      "span",
                                      { staticClass: "shift-record-uploader" },
                                      [
                                        _c("img", {
                                          staticStyle: {
                                            height: "100%",
                                            width: "100%"
                                          },
                                          attrs: { src: scope.row.checkImg }
                                        }),
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "el-upload-list__item-actions"
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "el-upload-list__item-preview",
                                                on: {
                                                  click: function($event) {
                                                    return _vm.handleUploadPreview(
                                                      scope.row,
                                                      "checkImg"
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _c("i", {
                                                  staticClass: "el-icon-zoom-in"
                                                })
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                }
                              }
                            ])
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "系统实际销售(升)",
                              prop: "gunEndMass",
                              align: "center"
                            }
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "升数差异(升)",
                              prop: "gunEndMass",
                              align: "center"
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    (
                                      scope.row.checkGunEndMass -
                                      scope.row.gunEndMass
                                    ).toFixed(2) == 0
                                      ? _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              (
                                                scope.row.checkGunEndMass -
                                                scope.row.gunEndMass
                                              ).toFixed(2)
                                            )
                                          )
                                        ])
                                      : _vm._e(),
                                    (
                                      scope.row.checkGunEndMass -
                                      scope.row.gunEndMass
                                    ).toFixed(2) != 0
                                      ? _c(
                                          "span",
                                          { staticStyle: { color: "red" } },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                (
                                                  scope.row.checkGunEndMass -
                                                  scope.row.gunEndMass
                                                ).toFixed(2)
                                              )
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ]
                                }
                              }
                            ])
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-tab-pane",
                { attrs: { label: "油罐数据", name: "oilTankData" } },
                [
                  _c(
                    "el-row",
                    {
                      staticClass: "bairun-dialog-table",
                      attrs: { gutter: 20 }
                    },
                    [
                      _c(
                        "el-table",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            data: _vm.shiftTableData.shiftOilTankList,
                            border: "",
                            stripe: "",
                            "tooltip-effect": "dark",
                            "row-class-name": "shift-dialog-table-row"
                          }
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              label: "油罐编号",
                              prop: "oilTankNo",
                              align: "center"
                            }
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "油罐名称",
                              prop: "oilTankName",
                              align: "center"
                            }
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "油品",
                              prop: "oilCode",
                              align: "center"
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _vm._v("#" + _vm._s(scope.row.oilCode))
                                  ]
                                }
                              }
                            ])
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "液位仪拍照",
                              prop: "tankImg",
                              align: "center"
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c(
                                      "span",
                                      { staticClass: "shift-record-uploader" },
                                      [
                                        _c("img", {
                                          staticStyle: {
                                            height: "100%",
                                            width: "100%"
                                          },
                                          attrs: { src: scope.row.tankImg }
                                        }),
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "el-upload-list__item-actions"
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "el-upload-list__item-preview",
                                                on: {
                                                  click: function($event) {
                                                    return _vm.handleUploadPreview(
                                                      scope.row,
                                                      "tankImg"
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _c("i", {
                                                  staticClass: "el-icon-zoom-in"
                                                })
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                }
                              }
                            ])
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-tab-pane",
                { attrs: { label: "支付数据", name: "payData" } },
                [
                  _c(
                    "el-row",
                    {
                      staticClass: "bairun-dialog-table",
                      attrs: { gutter: 20 }
                    },
                    [
                      _c(
                        "el-table",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            data: _vm.shiftTableData.shiftPaywayList,
                            border: "",
                            stripe: "",
                            "tooltip-effect": "dark",
                            "row-class-name": "shift-dialog-table-row"
                          }
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              label: "支付方式",
                              prop: "payWayName",
                              align: "center"
                            }
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "录入单数",
                              prop: "checkOrders",
                              align: "center"
                            }
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "录入应付金额",
                              prop: "checkPayablesAmount",
                              align: "center"
                            }
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "录入实付金额",
                              prop: "checkPaymentsAmount",
                              align: "center"
                            }
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "系统单数",
                              prop: "shiftOrders",
                              align: "center"
                            }
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "系统应付",
                              prop: "shiftPayablesAmount",
                              align: "center"
                            }
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "系统实付",
                              prop: "shiftPaymentsAmount",
                              align: "center"
                            }
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "单数差异",
                              prop: "shiftOrders",
                              align: "center"
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    (
                                      scope.row.checkOrders -
                                      scope.row.shiftOrders
                                    ).toFixed(2) == 0
                                      ? _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              (
                                                scope.row.checkOrders -
                                                scope.row.shiftOrders
                                              ).toFixed(2)
                                            )
                                          )
                                        ])
                                      : _vm._e(),
                                    (
                                      scope.row.checkOrders -
                                      scope.row.shiftOrders
                                    ).toFixed(2) != 0
                                      ? _c(
                                          "span",
                                          { staticStyle: { color: "red" } },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                (
                                                  scope.row.checkOrders -
                                                  scope.row.shiftOrders
                                                ).toFixed(2)
                                              )
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ]
                                }
                              }
                            ])
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "应付差异",
                              prop: "shiftPayablesAmount",
                              align: "center"
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    (
                                      scope.row.checkPayablesAmount -
                                      scope.row.shiftPayablesAmount
                                    ).toFixed(2) == 0
                                      ? _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              (
                                                scope.row.checkPayablesAmount -
                                                scope.row.shiftPayablesAmount
                                              ).toFixed(2)
                                            )
                                          )
                                        ])
                                      : _vm._e(),
                                    (
                                      scope.row.checkPayablesAmount -
                                      scope.row.shiftPayablesAmount
                                    ).toFixed(2) != 0
                                      ? _c(
                                          "span",
                                          { staticStyle: { color: "red" } },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                (
                                                  scope.row
                                                    .checkPayablesAmount -
                                                  scope.row.shiftPayablesAmount
                                                ).toFixed(2)
                                              )
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ]
                                }
                              }
                            ])
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "实付差异",
                              prop: "shiftPayablesAmount",
                              align: "center"
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    (
                                      scope.row.checkPaymentsAmount -
                                      scope.row.shiftPaymentsAmount
                                    ).toFixed(2) == 0
                                      ? _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              (
                                                scope.row.checkPaymentsAmount -
                                                scope.row.shiftPaymentsAmount
                                              ).toFixed(2)
                                            )
                                          )
                                        ])
                                      : _vm._e(),
                                    (
                                      scope.row.checkPaymentsAmount -
                                      scope.row.shiftPaymentsAmount
                                    ).toFixed(2) != 0
                                      ? _c(
                                          "span",
                                          { staticStyle: { color: "red" } },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                (
                                                  scope.row
                                                    .checkPaymentsAmount -
                                                  scope.row.shiftPaymentsAmount
                                                ).toFixed(2)
                                              )
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ]
                                }
                              }
                            ])
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c("el-button", { on: { click: _vm.closeDialog } }, [
                _vm._v("取 消")
              ]),
              _vm.type == "check"
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.handleRemark }
                    },
                    [_vm._v("提交")]
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: { visible: _vm.previewDialogVisible },
          on: {
            "update:visible": function($event) {
              _vm.previewDialogVisible = $event
            }
          }
        },
        [
          _c("img", {
            attrs: { width: "100%", src: _vm.previewDialogImageUrl, alt: "" }
          })
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }